import React from 'react'
import { Typography, Select, Form, Col } from 'antd'
import _ from 'lodash'
import {
  titleQuestion,
  numeroPostiLetto,
  numeroCamereLetto,
  numeroBagni,
  numeroCoinquilini
} from '../assets/constants'

const { Title, Text } = Typography

const PostiLetto = (props) => (
  <Form.Item name='numeroPostiLetto' rules={[{ required: true }]}>
    <Select placeholder='Numero posti letto'>
      {_.map(numeroPostiLetto, (item, key) => (
        <Select.Option key={`numero_letti_${key}`} value={item.value}>
          <Text>{item.label}</Text>
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
)

const CamereLetto = (props) => (
  <Form.Item name='numeroCamereLetto' rules={[{ required: true }]}>
    <Select placeholder='Numero camere da letto'>
      {_.map(numeroCamereLetto, (item, key) => (
        <Select.Option key={`numero_camere_${key}`} value={item.value}>
          <Text>{item.label}</Text>
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
)

const Bagni = (props) => (
  <Form.Item name='numeroBagni' rules={[{ required: true }]}>
    <Select placeholder='Numero bagni'>
      {_.map(numeroBagni, (item, key) => (
        <Select.Option key={`numero_bagni_${key}`} value={item.value}>
          <Text>{item.label}</Text>
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
)

const Coinquilini = (props) => (
  <Form.Item name='numeroCoinquilini' rules={[{ required: true }]}>
    <Select placeholder='Numero di coinquilini'>
      {_.map(numeroCoinquilini, (item, key) => (
        <Select.Option key={`numero_coiquilini_${key}`} value={item.value}>
          <Text>{item.label}</Text>
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
)

const TipoBagno = (props) => (
  <Form.Item name='tipoBagno' rules={[{ required: true }]}>
    <Select placeholder='Tipo di bagno'>
      <Select.Option value='0'>Privato</Select.Option>
      <Select.Option value='1'>Condiviso</Select.Option>
    </Select>
  </Form.Item>
)

const resetFields = (tipologia, removeValue) => {
  switch (tipologia) {
    case '0':
      removeValue([
        'numeroCamereLetto',
        'numeroBagni',
        'numeroCoinquilini',
        'tipoBagno'
      ])
      break
    case '1':
      removeValue(['numeroPostiLetto', 'numeroCoiquilini', 'tipoBagno'])
      break
    case '2':
      removeValue(['numeroPostiLetto', 'numeroCamereLetto'])
      break
    case '3':
      removeValue(['numeroPostiLetto', 'numeroCamereLetto', 'tipoBagno'])
      break
  }
}

const DicciDiPiu = (props) => {
  const tipologia = _.get(props, 'formValue.tipologia', '')
  resetFields(tipologia, props.removeValue)
  return (
    <>
      <Title>{_.get(titleQuestion, `[${parseInt(tipologia)}]`)}?</Title>
      <Col xs={24} sm={24} md={24} lg={12} span={12}>
        {/* MONOLOCALE */}
        {tipologia === '0' && <PostiLetto {...props} />}
        {/* APPARTAMENTO */}
        {tipologia === '1' && (
          <>
            <CamereLetto {...props} />
            <Bagni {...props} />
          </>
        )}
        {/* CAMERA */}
        {tipologia === '2' && (
          <>
            <Coinquilini {...props} />
            <Bagni {...props} />
            <TipoBagno {...props} />
          </>
        )}
        {/* POSTO LETTO */}
        {tipologia === '3' && (
          <>
            <Coinquilini {...props} />
            <Bagni {...props} />
          </>
        )}
      </Col>
    </>
  )
}

export default DicciDiPiu
